import {BADGE_STATUSES} from '@/consts/loyalty/badgeStatuses';
import {getBadgeDetailsContent} from '@/services/content/appContent';
import type {Badge} from '@/types/loyalty';

import BadgeActionList from './BadgeActionList';
import BadgeDetailHeader from './BadgeDetailHeader';

type BadgeDetailContentProps = {
    badge: Badge;
    titleId?: string;
};

/**
 * Content for a single-level badge detail drawer.
 * Layout: hero (bg image + badge + title + notification) → action list → description.
 */
const BadgeDetailContent = ({badge, titleId}: BadgeDetailContentProps) => {
    const {title, imageUrl, achievedImageUrl, status, actions} = badge;
    const hasActions = actions && actions.length > 0;
    const isEarned = status === BADGE_STATUSES.COMPLETED;

    const {singleLevelBadgeDetailsContent} = getBadgeDetailsContent();
    const {badgeBackgroundImage, howToEarnBadgeInlineNotification, badgeEarnedInlineNotification} =
        singleLevelBadgeDetailsContent ?? {};

    const notification = isEarned ? badgeEarnedInlineNotification : howToEarnBadgeInlineNotification;

    return (
        <div className='flex flex-col gap-4 pb-app-4'>
            <BadgeDetailHeader
                title={title}
                titleId={titleId}
                imageUrl={achievedImageUrl ?? imageUrl}
                backgroundImage={badgeBackgroundImage}
                notification={notification}
                isEarned={isEarned}
            />

            {/* Action list */}
            {hasActions && (
                <div className='px-4'>
                    <BadgeActionList actions={actions} />
                </div>
            )}
        </div>
    );
};

export default BadgeDetailContent;
